import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var base = "new-equity/";
var revamp = config.revamp;
var equityConfigURL = {
    indices: config.jmw + revamp + config.jmw_content + base + "indices-high-low",
    sectorPerformance: config.jmw + revamp + config.jmw_content + base + "sector-performance",
    advanceDecline: config.jmw + revamp + config.jmw_content + base + "advance-decline",
    weekHighlow: config.jmw + revamp + config.jmw_content + base + "52week-highlow",
    marketMap: config.jmw + revamp + config.jmw_content + base + "market-map",
    Recommendations: config.jmw + revamp + config.jmw_content + base + "research/active",
    insideTradingSast: config.jmw +
        config.jmw_news_content +
        "trendlyne/screeners/getInsiderTradingAndSastDeals",
    bulkBlockDeals: config.jmw +
        config.jmw_news_content +
        "trendlyne/screeners/getBulkBlockDeals",
    topGainersLosers: config.jmw + revamp + config.jmw_content + base + "top-gainers-losers",
    marketToday: config.jmw + revamp + config.jmw_content + base + "markets-today",
    ipos: config.jmw + config.jmw_market_env + config.jmw_market + "ipo",
    allTimeHighLow: config.jmw + revamp + config.jmw_content + base + "all-time-high-low",
    "52WeekHighLow": config.jmw + revamp + config.jmw_content + base + "52week-high-low",
    outUnderPerformers: config.jmw + revamp + config.jmw_content + base + "out-under-performer",
    fiiDii: config.jmw + revamp + config.jmw_content + base + "fii-dii",
    checkHoliday: config.jmw + revamp + config.jmw_content + base + "check-holiday",
    priceBuzzer: config.jmw + revamp + config.jmw_content + base + "price-buzzers",
    upperLowerCircuit: config.jmw + revamp + config.jmw_content + base + "upper-lower-circuit",
    volumeBuzzer: config.jmw + revamp + config.jmw_content + base + "volume-buzzers",
    understandingSection: config.jmw +
        config.jmw_market_env +
        config.jmw_market +
        "market/understanding-section",
    indexPullersDraggers: config.jmw + revamp + config.jmw_content + base + "index-pullers-dragger",
    advanceDeclineViewAll: config.jmw +
        revamp +
        config.jmw_content +
        base +
        "advance-decline-view-all",
    stockSurveillance: config.jmw + revamp + config.jmw_content + base + "stock/surveillance",
    indicesViewAll: config.jmw +
        revamp +
        config.jmw_content +
        base +
        "indices-high-low/view-all",
    CommodityOverview: config.jmwedel + config.jmw_content + "commodities/markets/overview",
};
export default equityConfigURL;
